import React from "react"
import { navigate, Link } from "gatsby"
import IconButton from "@material-ui/core/IconButton"
import MenuIcon from "@material-ui/icons/Menu"

const Header = props => {
  return (
    <header>
      <div className="Header">
        <h1 className="Header-logo" onClick={() => navigate("/")}>
          AB
        </h1>
        <nav className="Header-listWrapper">
          <ul className="Header-list">
            <li>
              <Link
                to="/about"
                className="Header-listItem"
                activeClassName="Header--active"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/gallery"
                className="Header-listItem"
                activeClassName="Header--active"
              >
                Gallery
              </Link>
            </li>
            <li>
              <Link
                to="/resume"
                className="Header-listItem"
                activeClassName="Header--active"
              >
                Resume
              </Link>
            </li>
            <li>
              <Link
                to="/coaching"
                className="Header-listItem"
                activeClassName="Header--active"
              >
                Coaching
              </Link>
            </li>
            <li>
              <Link
                to="/kudos"
                className="Header-listItem"
                activeClassName="Header--active"
              >
                Kudos
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="Header-listItem"
                activeClassName="Header--active"
              >
                Contact
              </Link>
            </li>
          </ul>
          <IconButton
            size="medium"
            color="inherit"
            aria-label="open drawer"
            onClick={props.handleOpenDrawer}
            edge="start"
            className="Header-iconWrapper"
          >
            <MenuIcon fontSize="inherit" />
          </IconButton>
        </nav>
      </div>
    </header>
  )
}

export default Header
